import apiV2 from '../api/v2';

export interface DmPracticeOption {
    practiceId: number;
    name: string;
    city: string | null;
    countryCode: string | null;
    email: string | null;
}

export interface DmDoctorOption {
    doctorId: number;
    fullName: string;
    email: string;
    mainPracticeId: number | null;
    practices: DmPracticeOption[];
}

export interface DmAddress {
    name: string;
    email: string;
    address: string;
    zipCode: string;
    city: string;
    regionCode?: string | null;
}

export interface CreateDmPracticeBody {
    idempotencyKey: string;
    locale: string;
    phone: string;
    firstname: string;
    lastname: string;
    countryCode: string;
    shipping: DmAddress;
    billing?: DmAddress | null;
}

export interface CreateDmDoctorBody {
    idempotencyKey: string;
    firstname: string;
    lastname: string;
    email: string;
    phone: string;
    locale: string;
    practiceIds: number[];
    mainPracticeId: number;
}

type Envelope<T> = { success: boolean; data: T };

export async function searchDmDoctors(
    practiceId: string,
    search: string,
    signal?: AbortSignal
): Promise<DmDoctorOption[]> {
    const response = await apiV2.get<Envelope<{ doctors: DmDoctorOption[] }>>(
        `/practices/${practiceId}/dm/doctors`,
        { params: { search }, signal }
    );
    return response.data.data.doctors;
}

export async function searchDmPractices(
    practiceId: string,
    search: string,
    signal?: AbortSignal
): Promise<DmPracticeOption[]> {
    const response = await apiV2.get<Envelope<{ practices: DmPracticeOption[] }>>(
        `/practices/${practiceId}/dm/practices`,
        { params: { search }, signal }
    );
    return response.data.data.practices;
}

export async function createDmPractice(
    practiceId: string,
    body: CreateDmPracticeBody
): Promise<DmPracticeOption> {
    const response = await apiV2.post<Envelope<{ practice: DmPracticeOption }>>(
        `/practices/${practiceId}/dm/practices`,
        body
    );
    return response.data.data.practice;
}

export async function createDmDoctor(
    practiceId: string,
    body: CreateDmDoctorBody
): Promise<DmDoctorOption> {
    const response = await apiV2.post<Envelope<{ doctor: DmDoctorOption }>>(
        `/practices/${practiceId}/dm/doctors`,
        body
    );
    return response.data.data.doctor;
}
